import HotentUi from '@transsion/hotent-ui'

const Icon = HotentUi.HtIcon

Icon.register({
  application: {
    width: 1024,
    height: 1024,
    d: 'M900.1 286.723l-388.8-223.7-388.2 224.9 0.7 448.6 388.9 223.7 388.2-224.9-0.8-448.6zM567 545.023v188.1H457v-187.6L274.9 443.122l54.5-95.5 182.1 102.401 183.478-110.206 55.9 94.8L567 545.023z',
  },
})

Icon.register({
  news: {
    width: 1147,
    height: 1024,
    paths: [
      {
        d: 'M448 432h208v64H448zM448 592h384v64H448zM192 752h640v64H192z',
      },
      {
        d: 'M64 64v896h896V64z m832 832H128V128h768z',
      },
      {
        d: 'M320 192h-32v64l32 64v-128zM320 336l-80-144h-48l80 144h48z',
      },
      {
        d: 'M240 272l-48-64v128h48v-64zM432 240h48v-48h-80v32h32v16zM432 320h-32v16h80v-32h-48v16z',
      },
      {
        d: 'M400 288h48v-32h-48v-64h-48v144h48v-48zM688 192h-32l-16 64 16 80 32-144zM640 336l-32-144h-48l48 144h32zM560 336l16-48-16-80-16 64-16-80h-48l48 144h32zM784 240h48v-16l-32-32h-48v32h32v16z',
      },
      {
        d: 'M784 288v48h16l32-16v-48l-32-32h-64v-48h-16l-16 32v32l16 32h64z',
      },
      {
        d: 'M784 336v-16h-48v-16h-32v16l16 16h64zM400 432H192v224h208z m-64 160h-80v-96h80z',
      },
    ],
  },
})

Icon.register({
  train: {
    width: 1024,
    height: 1024,
    d: 'M1089.477486 513.024q17.408 8.192 15.36 14.336t-15.36 7.168q-4.096 1.024-35.84 3.072t-77.312 5.632-97.792 7.168-96.768 7.168-75.264 5.632-32.768 2.048q-3.072-40.96 11.264-70.656 6.144-12.288 16.896-24.064t27.136-19.968 39.936-11.264 56.32 0q64.512 7.168 110.592 17.92t77.312 21.504 49.664 20.48 26.624 13.824zM631.749486 613.376q7.168-4.096 38.4-8.192t74.752-8.192 93.696-7.68 96.768-6.144 83.456-4.096 53.248-2.56l68.608-26.624-111.616 99.328 0-49.152-20.48 20.48-4.096 43.008-28.672 21.504-2.048-51.2-15.36 10.24-9.216 55.296-148.48 74.752-6.144-53.248-22.528 11.264-5.12 57.344-217.088 102.4 3.072-84.992-14.336 92.16q-83.968 40.96-150.528 59.392t-118.272 22.528-89.6-3.072-64-18.944-40.96-24.064-20.992-18.432q-2.048-19.456-3.072-43.008t-2.048-44.032q-1.024-23.552-1.024-47.104 15.36 20.48 41.472 33.792t56.832 21.504 62.976 11.264 60.416 3.584 49.664-1.536 30.72-4.096q17.408-4.096 48.128-13.824t62.464-19.968l59.392-20.48q25.6-8.192 33.792-11.264l517.12-204.8q-14.336 2.048-42.496 5.632t-65.024 8.704-78.848 11.776-82.944 12.8q-97.28 15.36-211.968 32.768-8.192-2.048-2.56-19.456t15.872-36.864q11.264-22.528 29.696-50.176-10.24 34.816-11.264 50.176t1.024 20.48q3.072 5.12 9.216 1.024zM1138.629486 482.304q6.144 6.144 7.68 13.312t-1.536 12.288-9.216 6.144-14.336-5.12q-5.12-4.096-33.28-29.184t-67.584-60.928-84.992-76.8-85.504-75.776-69.12-57.856-35.328-24.064q-8.192 0-24.576 22.016t-40.96 59.392-55.808 86.016-68.096 101.376-77.824 105.472-84.992 97.792-90.112 69.632-90.112 32.256-82.944 1.024-68.096-23.04-46.08-40.448-15.872-50.688q1.024-30.72 13.312-77.312t35.328-101.888 56.32-114.176 75.264-114.688 91.648-102.912 105.984-78.848q73.728-39.936 134.144-49.664t108.544-2.56 83.456 24.576 58.88 32.768q16.384 11.264 49.664 45.568t73.728 79.872 82.944 95.744 78.848 93.184 61.44 73.216 29.184 34.304zM73.669486 581.632q7.168-2.048 18.432-11.776t21.504-20.992 17.92-22.528 7.68-17.408-6.656-13.824-14.848-15.872q-10.24-9.216-21.504-18.432-11.264 17.408-19.456 38.912t-11.264 40.448-1.536 31.232 9.728 10.24zM310.213486 647.168q8.192-2.048 20.48-12.288t23.04-22.528 18.944-24.576 8.192-18.432-7.168-14.848-15.36-16.896q-10.24-9.216-22.528-19.456-12.288 18.432-20.992 41.984t-12.8 43.52-2.048 32.768 10.24 10.752zM428.997486 456.704q24.576 0 36.352-7.68t13.312-16.896-6.144-15.872-19.968-5.632q-55.296 7.168-103.424 3.072-20.48-1.024-40.96-4.608t-38.912-10.24-33.28-16.896-22.016-24.576q-12.288-3.072-21.504-1.024-8.192 2.048-12.288 8.192t1.024 20.48q7.168 19.456 23.552 32.256t38.4 20.992 47.616 11.776 50.688 5.12 47.616 1.536l39.936 0zM521.157486 321.536q17.408-16.384 38.4-43.52t38.912-57.856 29.184-60.416 10.24-50.176q-1.024-16.384-25.088-27.648t-59.904-14.336-76.8 4.096-74.752 28.672q-13.312 8.192-33.792 25.6t-42.496 39.424-42.496 46.08-33.28 46.08-14.848 39.424 12.288 25.6q11.264 6.144 32.768 11.776t48.128 8.704 55.808 4.096 55.808-1.024 48.64-8.192 33.28-16.384z',
  },
})

//顶部top-bar图标
Icon.register({
  message: {
    width: 1024,
    height: 1024,
    paths: [
      {
        d: 'M448 448a64 62.4 0 1 0 128 0 64 62.4 0 1 0-128 0Z',
      },
      {
        d: 'M213.2 448a64 62.4 0 1 0 128 0 64 62.4 0 1 0-128 0Z',
      },
      {
        d: 'M682.5 448a64 62.4 0 1 0 128 0 64 62.4 0 1 0-128 0Z',
      },
      {
        d: 'M359.4 939c-9.6 0-19.1-4.3-25.4-12.5-10.8-14-8.2-34.1 5.8-44.9L563.6 709H872c48.5 0 88-39.5 88-88V237c0-48.5-39.5-88-88-88H152c-48.5 0-88 39.5-88 88v384c0 48.5 39.5 88 88 88h69.6c17.7 0 32 14.3 32 32s-14.3 32-32 32H152C68.2 773 0 704.9 0 621V237C0 153.2 68.2 85 152 85h720c83.8 0 152 68.2 152 152v384c0 83.8-68.2 152-152 152H585.5L378.9 932.3c-5.8 4.5-12.7 6.6-19.5 6.7z',
      },
    ],
  },
})
Icon.register({
  apply: {
    width: 1024,
    height: 1024,
    paths: [
      {
        d: 'M544 552.32v247.68a32 32 0 0 1-32 32 31.36 31.36 0 0 1-32-32V552.32L256 423.04a32 32 0 0 1-11.52-43.52 31.36 31.36 0 0 1 43.52-11.52l224 128 222.08-128a31.36 31.36 0 0 1 43.52 11.52 32 32 0 0 1-11.52 43.52l-222.08 128z',
      },
      {
        d: 'M64 256v512l448 256 448-256V256L512 0z m832 480L512 960l-384-224v-448L512 64l384 224z',
      },
    ],
  },
})
Icon.register({
  themeSet: {
    width: 1024,
    height: 1024,
    paths: [
      {
        d: 'M512 51.2a460.8 460.8 0 0 0 0 921.6c78.5408 0 133.12-40.0384 139.264-102.4 2.3552-23.6544-6.5536-44.9536-15.1552-65.6384-14.336-34.5088-24.6784-59.4944 9.216-93.2864s73.5232-27.4432 119.7056-20.48c29.7984 4.5056 60.416 9.0112 89.1904 1.2288C929.5872 672.0512 972.8 606.208 972.8 512A461.312 461.312 0 0 0 512 51.2z m331.3664 601.9072c-20.48 5.5296-45.568 1.8432-71.68-2.2528-47.4112-7.0656-106.496-15.9744-154.7264 31.9488-53.4528 53.248-33.0752 102.4-18.1248 138.1376a105.2672 105.2672 0 0 1 12.1856 45.8752C604.672 927.1296 533.6064 931.84 512 931.84a419.84 419.84 0 1 1 419.84-419.84c0 43.6224-11.4688 120.1152-88.4736 141.1072z',
      },
      {
        d: 'M235.52 512m-51.2 0a51.2 51.2 0 1 0 102.4 0 51.2 51.2 0 1 0-102.4 0Z',
      },
      {
        d: 'M307.2 337.92m-51.2 0a51.2 51.2 0 1 0 102.4 0 51.2 51.2 0 1 0-102.4 0Z',
      },
      {
        d: 'M471.04 245.76m-51.2 0a51.2 51.2 0 1 0 102.4 0 51.2 51.2 0 1 0-102.4 0Z',
      },
      {
        d: 'M655.36 276.48m-51.2 0a51.2 51.2 0 1 0 102.4 0 51.2 51.2 0 1 0-102.4 0Z',
      },
      {
        d: 'M778.24 419.84m-51.2 0a51.2 51.2 0 1 0 102.4 0 51.2 51.2 0 1 0-102.4 0Z',
      },
    ],
  },
})
Icon.register({
  fullScreen: {
    width: 1024,
    height: 1024,
    d: 'M808.533333 170.666667 554.666667 170.666667c-17.066667 0-32-14.933333-32-32S537.6 106.666667 554.666667 106.666667l298.666667 0c38.4 0 64 32 64 81.066667L917.333333 469.333333c0 17.066667-14.933333 32-32 32S853.333333 486.4 853.333333 469.333333L853.333333 215.466667l-211.2 211.2c-6.4 6.4-14.933333 8.533333-23.466667 8.533333s-17.066667-2.133333-23.466667-8.533333c-12.8-12.8-12.8-32 0-44.8L808.533333 170.666667zM215.466667 853.333333 469.333333 853.333333c17.066667 0 32 14.933333 32 32S486.4 917.333333 469.333333 917.333333L181.333333 917.333333C136.533333 917.333333 106.666667 864 106.666667 825.6L106.666667 533.333333c0-17.066667 14.933333-32 32-32S170.666667 516.266667 170.666667 533.333333l0 275.2 211.2-211.2c12.8-12.8 32-12.8 44.8 0 12.8 12.8 12.8 32 0 44.8L215.466667 853.333333z',
  },
})
Icon.register({
  compress: {
    width: 1024,
    height: 1024,
    d: 'M577.212632 475.351579a53.894737 53.894737 0 0 1-53.409685-47.157895L523.317895 421.456842V67.260632h53.894737V421.456842h354.088421v53.894737h-354.088421zM574.356211 466.566737L536.252632 428.463158l350.315789-350.31579 38.103579 38.103579zM419.84 524.988632a53.894737 53.894737 0 0 1 53.409684 47.157894l0.431158 6.736842v354.142316h-53.894737v-354.088421H65.751579v-53.894737h354.088421zM422.696421 530.485895l38.103579 38.103579-350.315789 350.315789-38.103579-38.103579z',
  },
})
//邮件中心
Icon.register({
  mail: {
    width: 1024,
    height: 1024,
    d: 'M511.7 547.5l349.8-305.6c-11.4-10.7-26.4-16.8-42-17.2H203.9c-15.6 0.4-30.5 6.3-42 16.8l349.8 306z m22.1 74.7a34.14 34.14 0 0 1-43.8 0L136.2 313.1v414.8c-0.7 38.5 29.6 70.4 68.1 71.6h615.6c38.5-1.1 69-33.1 68.1-71.6V313.1L533.8 622.2z m0 0',
  },
})
Icon.register({
  pencil: {
    width: 1024,
    height: 1024,
    d: 'M1007.603765 229.385649l-103.751883 103.751883-212.989414-212.989414L794.614351 16.396235A54.746764 54.746764 0 0 1 834.879005 0.012434c15.944949 0 29.366501 5.485648 40.301225 16.383801l132.423535 132.423535c10.934724 10.934724 16.383801 24.356276 16.383801 40.301225 0 15.908378-5.485648 29.32993-16.383801 40.264654zM0 811.010586l629.386643-629.386643 213.025985 212.952843L212.989414 1024H0v-212.989414z',
  },
})
//菜单图标
Icon.register({
  home: {
    width: 1024,
    height: 1024,
    d: 'M795.401466 1023.997157h-197.508726a36.112307 36.112307 0 0 1-36.624135-36.794744v-316.650904H448.154624v316.650904a36.112307 36.112307 0 0 1-36.624134 36.794744H217.206471a110.327362 110.327362 0 0 1-109.929274-110.327363v-323.077188H86.576599A85.816489 85.816489 0 0 1 0.5895 504.264289a82.404303 82.404303 0 0 1 23.885306-59.201435L395.606953 50.045401a160.145285 160.145285 0 0 1 226.171092-6.426284 12.397611 12.397611 0 0 0 6.369415 6.426284l371.132147 395.017453a86.214578 86.214578 0 0 1-1.592353 121.587577 85.304661 85.304661 0 0 1-60.50944 23.942175h-31.847074v323.077188a110.327362 110.327362 0 0 1-109.929274 110.327363z m-159.235368-73.532619h159.235368a38.842056 38.842056 0 0 0 38.216489-38.387097v-358.279579a36.112307 36.112307 0 0 1 36.624134-36.737874h68.24373a12.056392 12.056392 0 0 0 11.373954-8.018638 12.738829 12.738829 0 0 0-3.184707-14.388053L574.007435 101.228198a85.816489 85.816489 0 0 0-122.668103-3.184707 3.412186 3.412186 0 0 0-3.184708 3.184707L77.022477 494.767037a12.56822 12.56822 0 0 0 0 17.57276 11.373955 11.373955 0 0 0 9.554122 3.241577h58.917086a36.112307 36.112307 0 0 1 36.624135 36.737874v359.871932a38.842056 38.842056 0 0 0 38.216488 38.387098h157.699885v-279.913029A73.1914 73.1914 0 0 1 451.282462 597.13263h113.113981a73.1914 73.1914 0 0 1 73.248269 73.532619z m0 0',
  },
})
Icon.register({
  matter: {
    width: 1024,
    height: 1024,
    d: 'M568.872592 853.345556H227.343694a56.90926 56.90926 0 0 1-56.90926-56.90926V625.781852a56.90926 56.90926 0 0 1 113.745184 0v113.745184h284.472964V625.781852a56.90926 56.90926 0 0 1 56.90926-56.90926h341.308888a56.90926 56.90926 0 0 1 56.90926 56.90926v341.308888a56.90926 56.90926 0 0 1-56.90926 56.90926H625.561842a56.90926 56.90926 0 0 1-56.90926-56.90926zM455.127408 284.472964V398.218148a56.90926 56.90926 0 0 1-56.90926 56.90926H56.90926A56.90926 56.90926 0 0 1 0 398.218148V56.90926A56.90926 56.90926 0 0 1 56.90926 0H398.218148a56.90926 56.90926 0 0 1 56.90926 56.90926v113.745184h341.308888a56.90926 56.90926 0 0 1 56.90926 56.90926V398.218148a56.90926 56.90926 0 1 1-113.745184 0V284.472964z m-341.308888 56.90926h227.343694v-227.343694h-227.343694z m568.872592 568.872592h227.343694v-227.343694h-227.343694z',
  },
})
Icon.register({
  unfold: {
    width: 1024,
    height: 1024,
    d: 'M320.47104 356.92544l-171.2128 171.66336 169.82016 169.82016 1.39264-341.48352zM147.61984 762.6752h750.10048v81.22368H147.61984zM416.48128 487.05536h481.19808v81.22368H416.48128zM147.61984 211.39456h750.10048v81.22368H147.61984z',
  },
})
Icon.register({
  fold: {
    width: 1024,
    height: 1024,
    d: 'M726.26176 698.40896l169.7792-169.82016-171.2128-171.66336 1.4336 341.48352zM897.67936 843.89888H147.57888V762.6752h750.10048zM628.77696 568.27904H147.57888v-81.22368h481.19808zM897.67936 292.6592H147.57888V211.43552h750.10048z',
  },
})
// 首页轮播图版块图标
Icon.register({
  todo: {
    width: 1024,
    height: 1024,
    fill: '#FF9325',
    d: 'M0 0m512 0l18.285714 0q512 0 512 512l0 0q0 512-512 512l-18.285714 0q-512 0-512-512l0 0q0-512 512-512Z',
  },
})
Icon.register({
  done: {
    width: 1024,
    height: 1024,
    d: 'M179.861 214.684v79.286H853.79v-79.286H179.861z m237.841 317.135H853.79v-79.286H417.702v79.286z m-237.84 277.497h673.927V730.03H179.861v79.286z m158.563-436.069L170.21 504.063l168.214 146.681V373.247z',
  },
})
Icon.register({
  request: {
    width: 1024,
    height: 1024,
    d: 'M179.861 214.684v79.286H853.79v-79.286H179.861z m237.841 317.135H853.79v-79.286H417.702v79.286z m-237.84 277.497h673.927V730.03H179.861v79.286z m158.563-436.069L170.21 504.063l168.214 146.681V373.247z',
  },
})
Icon.register({
  turn: {
    width: 1024,
    height: 1024,
    d: 'M179.861 214.684v79.286H853.79v-79.286H179.861z m237.841 317.135H853.79v-79.286H417.702v79.286z m-237.84 277.497h673.927V730.03H179.861v79.286z m158.563-436.069L170.21 504.063l168.214 146.681V373.247z',
  },
})

//流程图
Icon.register({
  flow: {
    width: 1024,
    height: 1024,
    paths: [
      {
        d: 'M672.853333 1024V682.666667h346.453334v341.333333zM4.693333 500.906667L249.6 256 431.36 440.32l-23.893333 60.586667 15.36 69.12-170.666667 170.666666zM672.853333 341.333333V0h346.453334v341.333333z',
      },
      {
        d: 'M718.08 912.213333H398.08V111.786667h274.773333v85.333333H483.413333v629.76h234.666667v85.333333z',
      },
    ],
  },
})
//流程图
Icon.register({
  process: {
    width: 1024,
    height: 1024,
    d: 'M512 163.584h140.8V263.04H561.792v497.792H652.8v99.52H462.208V163.584H512zM716.8 64h170.688a64 64 0 0 1 64 64v120.896a64 64 0 0 1-64 64H716.8a64 64 0 0 1-64-64V128a64 64 0 0 1 64-64zM299.84 346.048L420.48 466.752a64 64 0 0 1 0 90.496l-120.64 120.704a64 64 0 0 1-90.496 0L88.64 557.248a64 64 0 0 1 0-90.496L209.28 346.048a64 64 0 0 1 90.496 0z m416.96 365.056h170.688a64 64 0 0 1 64 64V896a64 64 0 0 1-64 64H716.8a64 64 0 0 1-64-64v-120.896a64 64 0 0 1 64-64z',
  },
})
//圆点
Icon.register({
  dot: {
    width: 1024,
    height: 1024,
    d: 'M320 513.4a192 192 0 1 0 384 0 192 192 0 1 0-384 0z',
  },
})
Icon.register({
  numberIcon: {
    width: 1024,
    height: 1024,
    paths: [
      {
        d: 'M299.52 416.0256l411.30496 0 0 20.21376-411.30496 0 0-20.21376Z',
      },
      {
        d: 'M282.45504 620.48256l428.37504 0 0 20.21376-428.37504 0 0-20.21376Z',
      },
      {
        d: 'M370.39104 779.38688 427.5968 280.35072 447.70304 282.10688 390.5024 781.13792Z',
      },
      {
        d: 'M534.23104 779.38688 591.4368 280.35072 611.54304 282.10688 554.3424 781.13792Z',
      },
    ],
  },
})

Icon.register({
  collection: {
    width: 1024,
    height: 1024,
    d: 'M1021.775237 398.27192a51.476886 51.476886 0 0 0-40.771927-37.234637l-291.174864-54.176397L558.110916 29.462838a49.894414 49.894414 0 0 0-91.038688 0l-130.32123 277.398048-291.267951 55.851955a51.383799 51.383799 0 0 0-42.633659 36.024512 55.851956 55.851956 0 0 0 12.752863 55.851956l212.516692 206.931497-55.014176 299.366484a55.851956 55.851956 0 0 0 20.47905 52.780098 52.407752 52.407752 0 0 0 53.897138 3.909637l264.365925-137.116552 263.993578 137.209639a48.591202 48.591202 0 0 0 53.804051-3.816551 55.851956 55.851956 0 0 0 20.47905-52.873185l-53.338618-299.552657 210.561874-207.862362a55.851956 55.851956 0 0 0 14.614596-55.20035z m0 0',
  },
})
Icon.register({
  NotCollected: {
    width: 1024,
    height: 1024,
    d: 'M773.458 1005.43c-14.403 0-30.592-4.132-45.599-11.638L513.567 886.61 297.948 993.618c-13.655 7.27-29.286 11.09-45.225 11.09a96.164 96.164 0 0 1-57.549-18.842c-30.177-22.64-45.64-61.85-38.502-97.561l44.099-228.772L31.744 501.996a104.059 104.059 0 0 1-26.281-100.66l0.338-1.162c12.288-36.828 42.772-62.633 79.734-67.584l234.839-42.7L425.779 75.811c16.932-33.895 51.37-55.675 87.788-55.675 37.99 0 73.318 22.6 88.13 56.29l105.068 213.4L941.64 330.89a95.672 95.672 0 0 1 78.264 68.373 98.97 98.97 0 0 1-24.474 101.002l-0.578 0.579-168.55 158.72L868.9 888.745c6.86 36.649-7.716 73.672-38.062 96.742a90.409 90.409 0 0 1-57.38 19.943z m-259.81-196.055l227.667 113.853c6.686 3.37 14.392 5.489 19.665 5.489 8.116 0 15.652-2.499 21.187-7.117l1.03-0.85c12.937-9.707 19.245-25.134 16.414-40.238l-45.814-246.804 181.212-170.65c11.126-11.28 14.93-27.433 9.995-42.286l-0.497-1.562a37.31 37.31 0 0 0-30.971-27.003l-1.034-0.163L661.76 348.21 548.91 118.99c-5.478-12.805-20.347-22.098-35.359-22.098-14.75 0-28.861 9.236-36.009 23.496L365.414 348.109l-252.062 45.788c-15.31 1.92-27.203 12.088-32.697 27.945-3.901 14.49 0.722 31.949 11.372 42.834l181.422 169.057-47.61 246.933c-2.863 14.28 3.9 30.714 16.409 40.1 6.272 4.715 14.397 7.316 22.917 7.316 6.569 0 12.866-1.531 18.294-4.45l0.783-0.46 229.407-113.797z',
  },
})
Icon.register({
  cardMore: {
    width: 1024,
    height: 1024,
    paths: [
      {
        d: 'M257.024 814.592c-19.968 0-36.352-16.384-36.352-36.352 0-9.728 4.096-18.944 10.752-25.6l240.128-240.64-240.128-240.128c-14.336-14.336-13.824-37.376 0.512-51.712 14.336-13.824 36.864-13.824 51.2 0l246.784 246.784c25.088 25.088 25.088 65.536 0 90.112L283.136 803.84c-7.168 6.656-16.384 10.752-26.112 10.752z',
      },
      {
        d: 'M512 814.592c-19.968 0-36.352-16.384-36.352-36.352 0-9.728 4.096-18.944 10.752-25.6l240.128-240.128-240.128-240.64c-14.336-14.336-13.824-37.376 0.512-51.712 14.336-13.824 36.864-13.824 51.2 0l246.784 246.784c25.088 24.576 25.088 65.024 0 90.112L537.6 803.84c-6.656 6.656-15.872 10.752-25.6 10.752z',
      },
    ],
  },
})
Icon.register({
  reset: {
    width: 1024,
    height: 1024,
    d: 'M98.190557 511.919958v-10.889379h-88.418037a10.051735 10.051735 0 0 1-8.562589-14.798387l142.306504-252.131013a9.307162 9.307162 0 0 1 16.752891 0l141.655002 252.131013a9.307162 9.307162 0 0 1-8.469517 14.798387H189.586886v10.889379a426.82644 426.82644 0 0 0 718.978248 306.112552l62.357984 65.61549a518.408912 518.408912 0 0 1-872.918704-371.728042z m971.574619 205.781348L927.551744 465.570293a9.958663 9.958663 0 0 1 8.469517-14.705316h100.610419A423.196647 423.196647 0 0 0 614.551893 90.119386a428.129442 428.129442 0 0 0-238.356414 71.944361l-49.979458-74.457295a518.688126 518.688126 0 0 1 802.463489 362.97931h91.210186a9.307162 9.307162 0 0 1 8.376445 14.705316l-141.561931 252.131013a8.748732 8.748732 0 0 1-8.09723 4.839724 10.051735 10.051735 0 0 1-8.841804-4.374366z',
  },
})
//登录页面图标
Icon.register({
  eyeSlash: {
    width: 1024,
    height: 1024,
    paths: [
      {
        d: 'M1472.109618 1023.587644a90.03098 90.03098 0 0 1-77.385408-43.709697L1214.249894 679.545593a90.168432 90.168432 0 1 1 154.495911-92.642566l179.924509 300.332354a90.03098 90.03098 0 0 1-77.247956 136.352263z m479.981959-300.332354a89.756077 89.756077 0 0 1-63.777671-26.390761l-239.99098-240.265883a90.168432 90.168432 0 1 1 127.417891-127.417891l239.99098 240.265883a90.168432 90.168432 0 0 1-63.777672 153.808652zM570.150392 1023.587644a88.931365 88.931365 0 0 1-46.183831-12.920476 90.03098 90.03098 0 0 1-30.926673-123.706691l180.061961-300.332354a90.168432 90.168432 0 0 1 154.495911 92.642566L647.673251 979.603043a90.03098 90.03098 0 0 1-77.660311 43.984601zM90.305884 723.25529a90.168432 90.168432 0 0 1-63.777671-153.808652l239.990979-240.265883a90.168432 90.168432 0 1 1 127.417892 127.417891L153.946104 696.864529a89.893528 89.893528 0 0 1-63.777672 26.390761z',
      },
      {
        d: 'M1050.132351 663.326271A1210.538693 1210.538693 0 0 1 95.666507 167.674797a753.236294 753.236294 0 0 0-8.934372-10.99615 90.168432 90.168432 0 0 1 121.644913-132.778514 274.903757 274.903757 0 0 1 27.490375 29.827057 1036.387163 1036.387163 0 0 0 814.814736 429.399668c365.8969 0 782.23864-377.717762 823.336751-437.784232a91.955307 91.955307 0 0 1 123.706691-26.803117 88.244106 88.244106 0 0 1 30.239413 120.132942c-42.884986 71.887332-511.870795 524.65382-977.832663 524.65382z',
      },
    ],
  },
})
Icon.register({
  eye: {
    width: 1024,
    height: 1024,
    paths: [
      {
        d: 'M1316.187178 525.000486C1131.689853 178.320848 844.981808 107.590233 732.211305 112.571262h-3.088239l-2.888997-0.099621h-3.088238a488.14087 488.14087 0 0 0-58.278042 2.291274 633.786166 633.786166 0 0 0-158.595973 37.158478 705.413367 705.413367 0 0 0-378.558225 351.660668 643.150501 643.150501 0 0 0 1188.473587 21.418425zM730.418134 12.751435c153.11684-5.678373 484.355287 89.060804 685.788112 488.14087l10.161299 20.023737-8.56737 21.119565A743.767293 743.767293 0 0 1 25.901352 518.226287l-7.471544-19.924118 9.563577-19.924117A811.110808 811.110808 0 0 1 471.10575 58.178422 730.019652 730.019652 0 0 1 654.90573 14.743847c23.510458-2.390894 42.53799-2.988618 56.08639-2.988618l19.326393 0.298862z',
      },
      {
        d: 'M719.659111 661.978792A149.430878 149.430878 0 1 1 871.680125 515.138048a149.430878 149.430878 0 0 1-152.021014 146.840744z m-1.69355 99.620585A249.748808 249.748808 0 1 0 472.500438 508.064987a249.748808 249.748808 0 0 0 245.465123 254.032493z',
      },
    ],
  },
})
Icon.register({
  password: {
    width: 1024,
    height: 1024,
    paths: [
      {
        d: 'M853.6342 387.74203H822.795358v-62.128985a310.644924 310.644924 0 1 0-621.214632 0v62.128985h-31.064493a62.128985 62.128985 0 0 0-62.128985 62.128985v496.956662a62.128985 62.128985 0 0 0 62.128985 62.128985h683.343617a62.128985 62.128985 0 0 0 62.128985-62.128985V449.871015a62.128985 62.128985 0 0 0-62.354635-62.128985z m-590.150139-62.128985a248.515939 248.515939 0 0 1 496.956662 0v62.128985H263.484061z m590.150139 621.214632H170.290583V449.871015h683.343617z',
      },
      {
        d: 'M512 574.128985a30.989276 30.989276 0 0 0-31.064492 31.064492v186.386955a31.064492 31.064492 0 1 0 62.128984 0V605.193477a30.989276 30.989276 0 0 0-31.064492-31.064492z',
      },
    ],
  },
})
Icon.register({
  user: {
    width: 1024,
    height: 1024,
    d: 'M510.800712 0a354.901678 354.901678 0 0 1 352.653568 357.299662 358.87334 358.87334 0 0 1-148.749964 291.729779 368.839962 368.839962 0 0 1 199.032697 320.730402 50.357671 50.357671 0 1 1-100.715341 0A257.783313 257.783313 0 0 0 609.118069 721.193782a668.962686 668.962686 0 0 0-98.317357-6.669394 656.747953 656.747953 0 0 0-97.418113 6.669394 258.38281 258.38281 0 0 0-204.503099 248.566061 50.357671 50.357671 0 1 1-100.715341 0 368.240466 368.240466 0 0 1 199.632194-320.730402A358.12397 358.12397 0 0 1 510.800712 0z m0 102.064207a255.235455 255.235455 0 1 0 251.86329 255.235455 253.586841 253.586841 0 0 0-251.86329-255.235455z',
  },
})
Icon.register({
  verificationCode: {
    width: 1024,
    height: 1024,
    d: 'M558.180083 915.169463a317.665384 317.665384 0 1 1-38.693551-481.502232L924.626135 28.527628a33.413575 33.413575 0 1 1 47.283362 47.283362l-47.283362 47.283361 118.208404 118.208404a33.413575 33.413575 0 1 1-47.283362 47.283362l-118.208403-118.208404-70.925043 70.925042 118.208404 118.208404a33.413575 33.413575 0 0 1-47.283361 47.283362l-118.208404-118.208404-189.842697 189.842696a317.350162 317.350162 0 0 1-11.11159 436.74065z m-401.908573-401.908573a250.838233 250.838233 0 1 0 354.625212 0 250.759427 250.759427 0 0 0-354.625212 0z',
  },
})
//待办
Icon.register({
  switch: {
    width: 1024,
    height: 1024,
    d: 'M297.865185 1005.595417L23.055701 674.119191c-22.182366-25.572684-7.168101-70.228014 23.732226-70.228014h878.673538a37.777828 37.777828 0 0 1 34.000045 40.877547l-3.58405 46.98012a37.874694 37.874694 0 0 1-34.000046 40.877548H331.768364a37.584096 37.584096 0 0 0-34.000045 40.586948l58.119736 220.854996c0 19.954443-11.04275 29.059868-24.604022 29.059868a46.108324 46.108324 0 0 1-33.418848-17.532787zM48.337786 378.386602l3.584051-46.98012a38.068427 38.068427 0 0 1 34.290644-40.877547h602.895392a37.777828 37.777828 0 0 0 34.290644-40.586949l-58.119736-220.854996c0-36.034236 36.324835-36.809166 58.119736-12.011412l274.809484 331.476227c22.182366 25.572684 7.071235 70.228014-23.732226 70.228014H82.725297A38.068427 38.068427 0 0 1 48.337786 378.096004z',
  },
})
//帮助
Icon.register({
  help: {
    width: 1024,
    height: 1024,
    paths: [
      {
        d: 'M892.8 351.1c-20.8-49.2-50.6-93.4-88.6-131.4-37.9-37.9-82.1-67.7-131.4-88.6-51-21.6-105.1-32.5-160.9-32.5S402 109.5 351 131.1c-49.2 20.8-93.4 50.6-131.4 88.6-37.9 37.9-67.7 82.1-88.6 131.4-21.6 51-32.5 105.1-32.5 160.9s10.9 109.9 32.5 160.9c20.8 49.2 50.6 93.4 88.6 131.4 37.9 37.9 82.1 67.7 131.4 88.6 51 21.6 105.1 32.5 160.9 32.5s109.9-10.9 160.9-32.5c49.2-20.8 93.4-50.6 131.4-88.6 37.9-37.9 67.7-82.1 88.6-131.4 21.6-51 32.5-105.1 32.5-160.9s-10.9-109.9-32.5-160.9z m-131 410.7C695.1 828.6 606.4 865.3 512 865.3s-183.1-36.8-249.8-103.5C195.4 695.1 158.7 606.4 158.7 512s36.8-183.1 103.5-249.8c66.7-66.7 155.5-103.5 249.8-103.5s183.1 36.8 249.8 103.5c66.7 66.7 103.5 155.5 103.5 249.8 0 94.4-36.7 183.1-103.5 249.8z',
      },
      {
        d: 'M512.9 240.8c-83 0-150.6 67.6-150.6 150.6 0 16.6 13.4 30 30 30s30-13.4 30-30c0-50 40.6-90.6 90.6-90.6s90.6 40.6 90.6 90.6c0 7-0.5 12.7-1.6 17.4-0.4 1.8-0.9 3.7-1.4 5.5-5 18.1-16.8 34.1-33.2 45.2-80.9 54.9-85.1 137.2-85.2 140.6-0.7 16.6 12.2 30.5 28.8 31.2h1.2c16 0 29.3-12.6 30-28.8 0-0.1 0.9-13.4 7.9-30.9 10.2-25.4 27.3-46.4 51-62.5 28.1-19 48.4-47 57.3-78.7 0.7-2.5 1.4-5.2 2-7.8 2.2-9.3 3.3-19.5 3.3-31.2-0.1-83-67.7-150.6-150.7-150.6z',
      },
      {
        d: 'M512 718.4m-42.3 0a42.3 42.3 0 1 0 84.6 0 42.3 42.3 0 1 0-84.6 0Z',
      },
    ],
  },
})
//流程分类文件夹图标
Icon.register({
  flowFiles: {
    width: 1024,
    height: 1024,
    paths: [
      {
        d: 'M94.976006 359.747029l-95.049121 327.553892v-628.786489a60.758322 60.758322 0 0 1 62.366846-58.491766h296.62637a63.975369 63.975369 0 0 1 43.868825 17.255071l127.950739 120.273694a12.648844 12.648844 0 0 0 8.84688 3.436392h445.999719a60.685208 60.685208 0 0 1 62.366845 58.491766v82.180932H203.332003a111.646159 111.646159 0 0 0-108.355997 78.086508z',
        fill: '#FFA000',
      },
      {
        d: 'M1157.113368 483.457115a62.439961 62.439961 0 0 0-48.913739-23.104248H199.383809a61.270125 61.270125 0 0 0-59.369143 43.357022l-127.65828 445.999719a58.491766 58.491766 0 0 0 43.210792 72.091102 65.803237 65.803237 0 0 0 16.158351 1.974097H980.468234a61.34324 61.34324 0 0 0 59.442258-43.283907l127.65828-445.999719a56.078981 56.078981 0 0 0-10.455404-51.180296z',
        fill: '#FFCA28',
      },
    ],
  },
})
//应用中心选中标签
Icon.register({
  checked: {
    width: 1024,
    height: 1024,
    paths: [
      {
        d: 'M1170.285714 1005.714286H53.321143L1298.285714 37.376V877.714286c0 70.582857-57.417143 128-128 128z',
      },
      {
        d: 'M1280 74.752L106.569143 987.428571H1170.285714c60.489143 0 109.714286-49.225143 109.714286-109.714285V74.752M1316.571429 0v877.714286a146.285714 146.285714 0 0 1-146.285715 146.285714H0L1316.571429 0z',
      },
      {
        d: 'M658.285714 648.704l37.302857-37.010286 171.666286 150.235429S994.816 640.365714 1228.361143 438.857143l15.067428 38.765714S1048.795429 671.378286 866.377143 877.714286z',
        fill: '#FFFFFF',
      },
    ],
  },
})
